import { TemplateNavHeaderStyles } from "./NavHeader-Level1.styles"

const t = document.createElement('template')
t.innerHTML = `
  <!-- TODO: class needed for "menu-open" -->
  <header class="ascend-header ascend-header-level1 header-inner" role="banner">
    <!-- Top Header: -->
    <nav class="main-nav" role="navigation" aria-label="Main Navigation">
      <!-- logo -->
      <slot name="logo"></slot>
      <!-- Site action & profile menu -->
      <slot name="utilityNavigation"></slot>
    </nav>

    <slot name="primaryNavigationMobile"></slot>
    <div class="tab-header">
      <slot name="primaryNavigation"></slot> 
    </div>
  </header>
`
const TemplateNavHeader = t

class NavHeader extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(TemplateNavHeader.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavigationSiteHeader connectedCallback')
    this.addEventListener('toggle-hamburger', (event) => {

      console.log('toggle-hamburger event received from NavHeader', event)

      const navMobileComponents = this.shadowRoot?.ownerDocument?.getElementsByTagName('ts-navheader-mobile');
      if (navMobileComponents && navMobileComponents.length > 0) {
        const navMobile = navMobileComponents[0];
        if (navMobile) {
          const isOpen = navMobile.getAttribute('isopen') === 'true';
          navMobile.setAttribute('isopen', (!isOpen).toString());
        }
      }


      const navMobilePanel = this.shadowRoot?.getElementById('nav-mobile-panel');
      if (navMobilePanel) {
        navMobilePanel.classList.toggle('open');

        if (navMobilePanel.classList.contains('open')) {
          navMobilePanel.classList.remove('closed');
          navMobilePanel.classList.add('open');
        } else {
          navMobilePanel.classList.add('closed');
          navMobilePanel.classList.remove('open');
        }
      }
    })
  }
}
if (!customElements.get('ts-navheader-level1')) {
  customElements.define('ts-navheader-level1', NavHeader)
}
export { NavHeader }
